import { __assign } from "tslib";
import * as React from 'react';
import { renderAndMountComponent } from '@wix/answers-lib';
import { DrillMenuItem } from './drill-menu-item';
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
export var createDrillMenuItemDriver = function (wrapper) {
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, ".drill-menu-item", DrillMenuItem.name);
    return {
        isDisabled: function () { return baseDriver.hasClass('disabled'); },
        click: function () { return baseDriver.click(); }
    };
};
export var createDrillMenuItem = function (props) {
    var elem = renderAndMountComponent(React.createElement(DrillMenuItem, __assign({}, props), props.children));
    return createDrillMenuItemDriver(elem);
};
//# sourceMappingURL=drill-menu-item.driver.js.map